import React from 'react'
import { Col, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import FontAwesome from 'react-fontawesome'
import haversine from 'haversine'

import Sentinel from '../Sentinel'
import Distance from './Distance'
import './Dealers.css'

export default class Dealers extends React.Component {
  render() {
    const { items, detail, app } = this.props
    let sas = app.searchAreaSupplemental || {}

    return items.map(item => {
      const format = detail
        ? {
            xs: 10,
            xsOffset: 2,
            sm: 9,
            smOffset: 3,
            md: 8,
            mdOffset: 4,
            lg: 7,
            lgOffset: 5,
          }
        : {
            xs: 10,
            xsOffset: 2,
            smOffset: 0,
            mdOffset: 0,
          }

      const address = multiLine => (
        <React.Fragment>
          {item.location.addressComponents.street.join(', ')}
          {multiLine ? <br /> : ', '}
          {item.location.addressComponents.city},{' '}
          {item.location.addressComponents.state}{' '}
          {item.location.addressComponents.zipCode}
          {item.phone ? <br /> : null}
          {item.phone
            .replace(/\D/g, '')
            .replace(/^(\d\d\d)(\d\d\d)(.*)$/, '($1) $2-$3')}
          <br />
          {multiLine ? <br /> : null}
          <Sentinel silent>
            <i>
              (<Distance here={sas} there={item.location} />)
            </i>
          </Sentinel>
        </React.Fragment>
      )

      return (
        <Col
          xs={12}
          key={item.did}
          componentClass="article"
          className="data-item"
        >
          <Col xs={12} className="container">
            <Col className="dealer-name" sm={4} {...format}>
              <h4>{item.name}</h4>
            </Col>
            <Col className="dealer-address" sm={5} {...format}>
              <address className="hidden-sm hidden-md hidden-lg">
                {address(true)}
              </address>
              <address className="hidden-xs">{address(detail)}</address>
            </Col>
            <Col className="links" sm={3} {...format}>
              {item.location &&
                item.location.address && (
                  <a
                    href={`https://maps.google.com/?q=${item.location.address}`}
                  >
                    <Button title="Map">
                      <FontAwesome name="map-o" />
                    </Button>
                  </a>
                )}
              {sas.address && (
                <a
                  href={`https://maps.google.com/?saddr=${sas.address}&daddr=${
                    item.location.address
                  }`}
                >
                  <Button title="Get directions">
                    <FontAwesome name="hand-o-right" />
                  </Button>
                </a>
              )}
              <Link
                to={{
                  pathname: `/dealers/${item.did}/inventory`,
                  state: { dealer: item },
                }}
              >
                <Button
                  className="view-details"
                  title="Dealer's inventory listing"
                >
                  <FontAwesome name="automobile" />
                </Button>
              </Link>
              {item.website && (
                <a href={`http://${item.website}`} className="external-link">
                  <Button
                    className="view-details"
                    title={`Visit ${item.website}`}
                  >
                    <FontAwesome name="external-link" />
                  </Button>
                </a>
              )}
            </Col>
          </Col>
        </Col>
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/DataView/Dealers.js